//@flow
import React from 'react';
import { browserHistory } from 'react-router';
import AccessibleButtonWrapper from '../../Icon/components/AccessibleButtonWrapper.react';
import ZopimLoader from '../../Chat/components/ZopimLoader.react';
import QuoteActions from '../../Actions/quote';
import CookiesData from '../../Utils/cookies-data';
import QuoteAPI from '../../APIInterfaces/quotes';
import BaseModal from '../../Modal/components/BaseModal.react';

import type ProductModel from '../../Stores/Products/productModel';
import type QuoteItemsCollection from '../../Stores/Quote/quoteItemsCollection';

type Props = {
  numItems:number,
  quoteId:string,
  product:ProductModel,
  productIsGift:boolean,
  giftBoxInQuote?:boolean,
  close:() => void,
  quoteItems:QuoteItemsCollection,
};

export default class GiftModal extends React.Component<Props> {
  _getItemType() {
    return this.props.productIsGift ? 'gift box' : 'item';
  }

  _getAddBtnText() {
    if (this.props.productIsGift) return 'Yes, continue to add it to my cart';
    return `Yes, add the ${this._getItemType()} to my cart`;
  }

  _getCheckoutBtnClassName() {
    return this.props.giftBoxInQuote ? 'cta-secondary' : 'cta';
  }

  _getDescText() {
    const otherItems = this.props.giftBoxInQuote ? 'gift box' : `other ${this.props.numItems} items`;
    return `Do you want this ${this._getItemType()} to ship to the same address as the ${otherItems} in your cart?`;
  }

  _renderCheckoutBtn() {
    if (!this.props.productIsGift || !this.props.giftBoxInQuote) {
      return (
        <AccessibleButtonWrapper
          action={this._handleCheckoutClick}
          className={this._getCheckoutBtnClassName()}
          label="Checkout"
        >
          No, checkout with only the gift box
        </AccessibleButtonWrapper>
      );
    }
  }

  _renderCloseBtn() {
    if (!this.props.giftBoxInQuote || this.props.productIsGift) {
      const itemText = this.props.productIsGift ? 'it' : 'the gift box';
      return (
        <AccessibleButtonWrapper
          action={this.props.close}
          className="cta-secondary"
          label="Close notification"
        >
          Don&apos;t add {itemText} to my cart
        </AccessibleButtonWrapper>
      );
    }
  }

  _renderHelpText() {
    if (!this.props.giftBoxInQuote) {
      return (
        <p className="gift-notification-help">
          If you choose to checkout with only the gift box, the other items in your cart will be removed. You will need to add them again later.&nbsp;
          <ZopimLoader onlineText="Questions?" offlineText="Questions?" />
        </p>
      );
    }
  }

  _addItem = () => {
    CookiesData.set('giftNotification', true);
    QuoteActions.addQuoteItem(this.props.quoteId, this.props.product.getSku());
    this.props.close();
  }

  _handleCheckoutClick = () => {
    if (this.props.giftBoxInQuote) {
      this._goToCart();
    } else {
      const quoteId = this.props.quoteId;
      const currentItemIds = this.props.quoteItems.getIds();
      const items = currentItemIds.map(id => {
        return { id, qty: 0};
      });
      items.push({ sku: this.props.product.getSku(), qty: 1 });
      QuoteAPI.updateQuote(quoteId, { items })
        .onSuccess(this._goToCart);
    }
  }

  _goToCart = () => {
    this.props.close();
    browserHistory.push('/cart');
  }

  render() {
    return (
      <BaseModal
        className="gift-modal"
        isOpen={true}
        closeModal={this.props.close}
      >
        <h2>Ship it together?</h2>
        <p>
          Orders can only be sent to one address at a time.&nbsp;
          <span className="bold">{this._getDescText()}</span>
        </p>
        <div className="gift-notification-snack">
          <img
            src={this.props.product.getSnackcardImageUrl(40,40)}
            alt={this.props.product.getName()}
            className="gift-notification-snack-img"
          />
          <span className="gift-notification-snack-name">{this.props.product.getName()}</span>
        </div>
        <AccessibleButtonWrapper
          action={this._addItem}
          className="cta"
          label="Add to cart"
        >
          {this._getAddBtnText()}
        </AccessibleButtonWrapper>
        {this._renderCheckoutBtn()}
        {this._renderCloseBtn()}
        {this._renderHelpText()}
      </BaseModal>
    );
  }
}
